$(function () {
  $(".c-m-testimonials__carousel").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: false,
    infinite: true,
    speed: 500,
    fade: true,

    prevArrow: false,
    nextArrow: false,
    dots: true,
    //appendArrows: $(".c-m-testimonials__slick-arrows"),

    appendDots: $(".c-m-testimonials__slick-dots"),
  });

  //function repeaterCarousel() {
  $(".c-m-carousel-repeater__carousel").slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    centerMode: false,
    infinite: true,
    //prevArrow: $(".slick-prev"),
    //nextArrow: $(".slick-next"),
    //appendArrows: $(".slick-arrows"),
    responsive: [
      {
        breakpoint: 570,
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 800,
        settings: {
          slidesToShow: 2,
        },
      },
    ],
  });
  //}
  //repeaterCarousel();

  $(".c-m-carousel-repeater__tabs").on("click", function () {
    $(this).addClass("is-active").siblings().removeClass("is-active");
    var dataAtrr = $(this).attr("data-carousel");
    $(".c-m-carousel-repeater__content").addClass("is-hidden");
    $("#" + dataAtrr).removeClass("is-hidden");
    //repeaterCarousel();
    $(".c-m-carousel-repeater__carousel").slick("refresh");
  });
});

//========== Tabbed carousel ==============

// const carousel = document.querySelectorAll(".c-m-carousel-repeater__tabs");
// const toggleCarousel = (e) => {
//   e.preventDefault();
//   let el = e.target;
//   let dateAttr = el.getAttribute("data-carousel");
//   let track = document.querySelectorAll(".c-m-carousel-repeater__content");
//   let activeCarousel = document.querySelector("#" + dateAttr);
//   track.forEach((e) => {
//     e.classList.add("is-hidden");
//   });
//   carousel.forEach((e) => {
//     e.classList.remove("is-active");
//   });
//   e.currentTarget.classList.add("is-active");
//   activeCarousel.classList.remove("is-hidden");
// };
// carousel.forEach((e) => {
//   e.addEventListener("click", toggleCarousel);
// });
